(function () {
    'use strict';

    angular.module("imApp").factory("accountsService", ['$ihttp', function ($ihttp) {
        let service = {
            getAccounts: function (parms) {
                return $ihttp.post({
                    method: 2938,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
